// components/UnavailableList.js
import React, { useContext, useState, useRef } from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import { DataContext } from '../DataContext';

const UnavailableList = ({ onDragEnd, onDragStart, onDrop, onDragOver, onGetGoal }) => {
  
  const { data } = useContext(DataContext);

  const { setNodeRef } = useDroppable({
    id: "unavailable",
  });

  return (
    <div
      className={`droppable unavailable full-width section`}
      ref={setNodeRef} 
      onDrop={(event) => onDrop(event, 'unavailable')}
    >
      <div className="categoryTitle">
        Indisponível <span className="categorQuantity">({data.unavailable.length})</span>
      </div>
      <div className="card-container">
      {[...data.unavailable]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => (
          <DraggableCard key={item.uuid} item={item} onGetGoal={onGetGoal} />
      ))}
      </div>
    </div>
  );

}

const DraggableCard = ({ item, onGetGoal }) => {
  const S3_URL = process.env.REACT_APP_S3_URL;

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.uuid,
    data: { itemId: item.uuid, sourceCategory: "unavailable" },
  });

  // eslint-disable-next-line
  const [tapCount, setTapCount] = useState(0);
  const lastTapRef = useRef(0);
  const timeoutRef = useRef(null);

  const handlePointerUp = (event) => {
    // Ignore if dragging
    if (event.pointerType === "mouse" && (Math.abs(event.movementX) > 1 || Math.abs(event.movementY) > 1)) {
      return;
    }

    const now = Date.now();
    const timeDiff = now - lastTapRef.current;

    if (timeDiff < 500) {
      setTapCount(prev => {
        const newCount = prev + 1;
        if (newCount === 3) {
          clearTimeout(timeoutRef.current);
          onGetGoal(item)
          return 0;
        }
        return newCount;
      });

      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setTapCount(0);
      }, 600);
    } else {
      setTapCount(1);
    }

    lastTapRef.current = now;
  };

  const style = {
    transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined,
    touchAction: "none",
    position: "relative",
    zIndex: 1000,
  };

  return (
    <div 
      ref={setNodeRef} 
      className="card" 
      style={style} 
      {...listeners} 
      {...attributes}
      id={item.uuid}
      onPointerUp={handlePointerUp}
    >
      <div className="avatar">
        {item.avatar_url ? (
          <img 
            src={`${S3_URL}/img/user/${item.avatar_url}`}
            alt={item.name} 
            className="avatar-img"
          />
        ) : (
          <div className="avatar-unavailable">👤</div>
        )}
      </div>
      <div className="info unavailable">
        <span>{item.name}</span>
      </div>
    </div>
  );
};

export default UnavailableList;
